"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  AndroidSync: ['android-sync', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.75,19.067a6.029,6.029,0,0,1,4.56-5.824A.248.248,0,0,0,17.5,13V10.5a.75.75,0,0,0-.75-.75h-12A.75.75,0,0,0,4,10.5V20.524a1.222,1.222,0,0,0,1.212,1.228H12.5a.25.25,0,0,0,.25-.25Z', 'M3.97,7.173A1,1,0,0,0,4.914,8.5H16.583a1,1,0,0,0,.943-1.331A6.863,6.863,0,0,0,14.142,3.3a.251.251,0,0,1-.12-.313l.634-1.626A1,1,0,1,0,12.793.639l-.7,1.787a.249.249,0,0,1-.269.157A7.539,7.539,0,0,0,10.756,2.5a7.653,7.653,0,0,0-1.079.081.249.249,0,0,1-.269-.157L8.721.642a1,1,0,0,0-1.867.719L7.48,2.988a.25.25,0,0,1-.12.313A6.806,6.806,0,0,0,3.97,7.173ZM13,5a.75.75,0,1,1-.75.75A.75.75,0,0,1,13,5ZM8.5,5a.75.75,0,1,1-.75.75A.75.75,0,0,1,8.5,5Z', 'M20.75,11a1,1,0,0,0-2,0v2a.251.251,0,0,0,.239.25,5.9,5.9,0,0,1,1.44.24.249.249,0,0,0,.321-.239Z', 'M2.75,18V11a1,1,0,0,0-2,0v7a1,1,0,0,0,2,0Z', 'M22.6,20.03a.748.748,0,0,0-.953.467c-.03.088-.072.17-.11.254a2.957,2.957,0,0,1-2.694,1.75,2.927,2.927,0,0,1-1.09-.235,3.049,3.049,0,0,1-.9-.545.25.25,0,0,1-.011-.364L17.6,20.6a.5.5,0,0,0-.354-.853h-2.5a.5.5,0,0,0-.5.5v2.5a.5.5,0,0,0,.309.462.508.508,0,0,0,.191.038A.5.5,0,0,0,15.1,23.1l.326-.327a.252.252,0,0,1,.349-.005,4.457,4.457,0,0,0,7.292-1.789.728.728,0,0,0,.035-.268A.747.747,0,0,0,22.6,20.03Z', 'M23.25,15.751a.5.5,0,0,0-.309-.462.505.505,0,0,0-.545.108l-.326.327a.25.25,0,0,1-.349,0,4.459,4.459,0,0,0-7.292,1.789.734.734,0,0,0-.035.269.748.748,0,0,0,.5.685.768.768,0,0,0,.243.04.753.753,0,0,0,.71-.507,2.74,2.74,0,0,1,.11-.254A2.957,2.957,0,0,1,18.653,16a3.074,3.074,0,0,1,1.982.788.246.246,0,0,1,.081.179.252.252,0,0,1-.073.183L19.9,17.9a.5.5,0,0,0,.354.854h2.5a.5.5,0,0,0,.5-.5Z']],
  AndroidUpload: ['android-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.75,19.5a6.029,6.029,0,0,1,4.56-5.823.25.25,0,0,0,.19-.243V10.5a.75.75,0,0,0-.75-.75h-12A.75.75,0,0,0,4,10.5V20.524a1.221,1.221,0,0,0,1.212,1.227h7.62a.25.25,0,0,0,.237-.33A6.257,6.257,0,0,1,12.75,19.5Z', 'M3.97,7.172A1,1,0,0,0,4.914,8.5H16.583a1,1,0,0,0,.943-1.331A6.865,6.865,0,0,0,14.142,3.3a.25.25,0,0,1-.119-.314l.633-1.625A1,1,0,0,0,12.793.638l-.7,1.788a.252.252,0,0,1-.269.157A7.406,7.406,0,0,0,10.756,2.5a7.531,7.531,0,0,0-1.08.082.25.25,0,0,1-.268-.158L8.721.642a1,1,0,0,0-1.867.719L7.48,2.988a.249.249,0,0,1-.12.312A6.806,6.806,0,0,0,3.97,7.172ZM13,5a.75.75,0,1,1-.75.75A.75.75,0,0,1,13,5ZM8.5,5a.75.75,0,1,1-.75.75A.75.75,0,0,1,8.5,5Z', 'M20.75,11a1,1,0,1,0-2,0v2.256a.25.25,0,0,0,.239.249,5.95,5.95,0,0,1,1.44.241.249.249,0,0,0,.321-.24Z', 'M1.75,19a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v7A1,1,0,0,0,1.75,19Z', 'M14.25,19.5a4.5,4.5,0,1,0,4.5-4.5A4.5,4.5,0,0,0,14.25,19.5Zm2.646-.853,1.5-1.5a.5.5,0,0,1,.708,0l1.5,1.5a.5.5,0,0,1-.354.853h-.5a.25.25,0,0,0-.25.25V21.5a.75.75,0,1,1-1.5,0v-1.75a.25.25,0,0,0-.25-.25h-.5a.5.5,0,0,1-.354-.853Z']],
  Android: ['android', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5,10.251H4.5a3,3,0,0,0-3,3v4.5a1,1,0,0,0,2,0v-4.5a1,1,0,0,1,1-1h.25a.5.5,0,0,1,.5.5V19.5a.75.75,0,0,0,.75.75H7a.5.5,0,0,1,.5.5V23a1,1,0,0,0,2,0v-2.25a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,.5.5V23a1,1,0,1,0,2,0v-2.25a.5.5,0,0,1,.5-.5h1a.75.75,0,0,0,.75-.75v-6.75a.5.5,0,0,1,.5-.5h.25a1,1,0,0,1,1,1v4.5a1,1,0,1,0,2,0v-4.5A3,3,0,0,0,19.5,10.251Z', 'M6.459,3.374a.249.249,0,0,1,.02.33A6.963,6.963,0,0,0,5,8v.5a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5V8a6.963,6.963,0,0,0-1.479-4.3.249.249,0,0,1,.02-.33l1.666-1.666A1,1,0,1,0,17.793.294L16.04,2.046a.248.248,0,0,1-.31.034,6.984,6.984,0,0,0-7.46,0,.25.25,0,0,1-.31-.035L6.207.294A1,1,0,0,0,4.793,1.708ZM15.25,4.5V6a.75.75,0,1,1-1.5,0V4.5a.75.75,0,1,1,1.5,0Zm-5,1.5a.75.75,0,1,1-1.5,0V4.5a.75.75,0,1,1,1.5,0Z']],
  AndroidDownload: ['android-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.75,19.5a6.029,6.029,0,0,1,4.56-5.823.25.25,0,0,0,.19-.243V10.5a.75.75,0,0,0-.75-.75h-12A.75.75,0,0,0,4,10.5V20.524a1.221,1.221,0,0,0,1.212,1.227h7.62a.25.25,0,0,0,.237-.33A6.257,6.257,0,0,1,12.75,19.5Z', 'M3.97,7.172A1,1,0,0,0,4.914,8.5H16.583a1,1,0,0,0,.943-1.331A6.865,6.865,0,0,0,14.142,3.3a.25.25,0,0,1-.119-.314l.633-1.625A1,1,0,0,0,12.793.638l-.7,1.788a.251.251,0,0,1-.269.157A7.406,7.406,0,0,0,10.756,2.5a7.531,7.531,0,0,0-1.08.082.25.25,0,0,1-.268-.158L8.721.642a1,1,0,0,0-1.867.719L7.48,2.988a.249.249,0,0,1-.12.312A6.806,6.806,0,0,0,3.97,7.172ZM13,5a.75.75,0,1,1-.75.75A.75.75,0,0,1,13,5ZM8.5,5a.75.75,0,1,1-.75.75A.75.75,0,0,1,8.5,5Z', 'M20.75,11a1,1,0,1,0-2,0v2.256a.25.25,0,0,0,.239.249,5.95,5.95,0,0,1,1.44.241.249.249,0,0,0,.321-.24Z', 'M1.75,19a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v7A1,1,0,0,0,1.75,19Z', 'M14.25,19.5a4.5,4.5,0,1,0,4.5-4.5A4.5,4.5,0,0,0,14.25,19.5Zm2.538.309a.5.5,0,0,1,.462-.309h.5a.25.25,0,0,0,.25-.25V17.5a.75.75,0,0,1,1.5,0v1.75a.25.25,0,0,0,.25.25h.5a.5.5,0,0,1,.354.854l-1.5,1.5a.5.5,0,0,1-.708,0l-1.5-1.5A.5.5,0,0,1,16.788,19.81Z']],
  AndroidSettings: ['android-settings', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.274,19.145a.248.248,0,0,0,0-.287,2.894,2.894,0,0,1,2.608-4.544.251.251,0,0,0,.249-.144,2.869,2.869,0,0,1,1.237-1.319.252.252,0,0,0,.131-.22V10.5a.75.75,0,0,0-.75-.75h-12A.75.75,0,0,0,4,10.5V20.524a1.221,1.221,0,0,0,1.212,1.227h7.373a.25.25,0,0,0,.244-.306A2.89,2.89,0,0,1,13.274,19.145Z', 'M3.969,7.172A1,1,0,0,0,4.913,8.5H16.582a1,1,0,0,0,.943-1.331A6.865,6.865,0,0,0,14.141,3.3a.251.251,0,0,1-.12-.314l.634-1.625A1,1,0,1,0,12.792.638l-.7,1.788a.252.252,0,0,1-.269.157A7.406,7.406,0,0,0,10.755,2.5a7.52,7.52,0,0,0-1.08.082.251.251,0,0,1-.269-.158L8.72.642a1,1,0,0,0-1.868.719l.627,1.627a.249.249,0,0,1-.12.312A6.806,6.806,0,0,0,3.969,7.172ZM13,5a.75.75,0,1,1-.75.75A.75.75,0,0,1,13,5ZM8.5,5a.75.75,0,1,1-.75.75A.75.75,0,0,1,8.5,5Z', 'M20.749,11a1,1,0,0,0-2,0v1.26a.249.249,0,0,0,.23.249,2.868,2.868,0,0,1,1.38.481.249.249,0,0,0,.39-.207Z', 'M1.749,10a1,1,0,0,0-1,1v7a1,1,0,0,0,2,0V11A1,1,0,0,0,1.749,10Z', 'M22.873,18.147a1.393,1.393,0,0,0-1.329-2.307l-.982.228a.158.158,0,0,1-.19-.113l-.295-.967a1.387,1.387,0,0,0-2.656,0l-.295.967a.163.163,0,0,1-.191.113l-.982-.228a1.393,1.393,0,0,0-1.328,2.307l.686.74a.17.17,0,0,1,0,.229l-.686.74a1.392,1.392,0,0,0,1.329,2.306l.981-.227a.16.16,0,0,1,.191.112l.295.968a1.387,1.387,0,0,0,2.656,0l.295-.968a.157.157,0,0,1,.19-.112l.983.227a1.392,1.392,0,0,0,1.328-2.306l-.687-.74a.172.172,0,0,1,0-.229ZM18.749,20.5a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,18.749,20.5Z']],
  Android1: ['android-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.462,22.876H17.538a1.222,1.222,0,0,0,1.212-1.228V11.626a.75.75,0,0,0-.75-.75H6a.75.75,0,0,0-.75.75V21.648A1.222,1.222,0,0,0,6.462,22.876Z', 'M5.22,8.3a1,1,0,0,0,.944,1.329H17.833A1,1,0,0,0,18.776,8.3a6.863,6.863,0,0,0-3.384-3.867.248.248,0,0,1-.119-.313l.633-1.626a1,1,0,1,0-1.863-.726l-.7,1.788a.25.25,0,0,1-.269.156,7.406,7.406,0,0,0-1.071-.081,7.653,7.653,0,0,0-1.079.081.249.249,0,0,1-.269-.157L9.971,1.767A1,1,0,1,0,8.1,2.485L8.73,4.112a.25.25,0,0,1-.12.313A6.806,6.806,0,0,0,5.22,8.3Zm9.03-2.171a.75.75,0,1,1-.75.75A.75.75,0,0,1,14.25,6.126Zm-4.5,0a.75.75,0,1,1-.75.75A.75.75,0,0,1,9.75,6.126Z', 'M22,19.126v-7a1,1,0,1,0-2,0v7a1,1,0,1,0,2,0Z', 'M3,11.126a1,1,0,0,0-1,1v7a1,1,0,0,0,2,0v-7A1,1,0,0,0,3,11.126Z']]
};
exports["default"] = _default;